/**
 * Per-page-load sampling: 10% in production, 100% everywhere else (so
 * standalone/dev testing needs no setup). Manual override for testing:
 *
 *   localStorage.setItem('hydra:rumSampling', 'always')  // force on
 *   localStorage.setItem('hydra:rumSampling', 'never')   // force off
 *
 * Sampling is decided once per page load rather than stickily per user:
 * it's unbiased for percentiles and rate changes take effect immediately,
 * with no stale persisted draws.
 */

const OVERRIDE_STORAGE_KEY = 'hydra:rumSampling';
const PRODUCTION_SAMPLE_RATE = 0.1;

type SamplingOptions = {
  sampleRate?: number;
  random?: () => number;
};

export function shouldSampleRumSession(options: SamplingOptions = {}): boolean {
  try {
    const override = localStorage.getItem(OVERRIDE_STORAGE_KEY);
    if (override === 'always') {
      return true;
    }
    if (override === 'never') {
      return false;
    }
  } catch {
    // storage unavailable (privacy mode) — fall through to the sample rate
  }

  const sampleRate = options.sampleRate ?? (__CIO_ENV__ === 'production' ? PRODUCTION_SAMPLE_RATE : 1);
  return (options.random ?? Math.random)() < sampleRate;
}
